/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weeks: NonNullable<unknown> }} Wrapped_Window_CaptionInputs */

const en_us2_wrapped_window_caption = /** @type {(inputs: Wrapped_Window_CaptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last ${i?.weeks} weeks`)
};

const pt_br2_wrapped_window_caption = /** @type {(inputs: Wrapped_Window_CaptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Últimas ${i?.weeks} semanas`)
};

const es_419_wrapped_window_caption = /** @type {(inputs: Wrapped_Window_CaptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Últimas ${i?.weeks} semanas`)
};

const pt_pt2_wrapped_window_caption = /** @type {(inputs: Wrapped_Window_CaptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Últimas ${i?.weeks} semanas`)
};

const fr_fr2_wrapped_window_caption = /** @type {(inputs: Wrapped_Window_CaptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weeks} dernières semaines`)
};

const de_de2_wrapped_window_caption = /** @type {(inputs: Wrapped_Window_CaptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Letzte ${i?.weeks} Wochen`)
};

const it_it2_wrapped_window_caption = /** @type {(inputs: Wrapped_Window_CaptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ultime ${i?.weeks} settimane`)
};

/**
* | output |
* | --- |
* | "Last {weeks} weeks" |
*
* @param {Wrapped_Window_CaptionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_window_caption = /** @type {((inputs: Wrapped_Window_CaptionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Window_CaptionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_window_caption(inputs)
	if (locale === "es-419") return es_419_wrapped_window_caption(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_window_caption(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_window_caption(inputs)
	if (locale === "de-DE") return de_de2_wrapped_window_caption(inputs)
	if (locale === "it-IT") return it_it2_wrapped_window_caption(inputs)
	return en_us2_wrapped_window_caption(inputs)
});
export { wrapped_window_caption as "wrapped.window_caption" }